import axios from 'axios';

interface localDatosBienvenida {
    documento: string;
    apellido: string;
    nombres: string;
    email: string;
    celular: string;
    plan: string;
    importe: number;
};

interface localGrupoFamiliar {
    documento: string;
    apellido: string;
    nombres: string;
    email: string;
    celular: string;
    fecnac: string;
    tipoIntegrante: "" | "Titular" | "Conyuge" | "Menor" | "Mayor";
};

async function EnviarCorreoBienvenida(prmDatosBienvenida: localDatosBienvenida, prmGrupoFamiliar: localGrupoFamiliar[]) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/enviar_correo_bienvenida"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "datosBienvenida": prmDatosBienvenida,
            "grupoFamiliar": prmGrupoFamiliar
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default EnviarCorreoBienvenida;